import { NoMatchPage } from '@/components/NoMatchPage';

export default NoMatchPage;
